<template>
  <div class="w-full max-w-[448px] mx-auto mt-32 px-16 sm:px-0 pb-32">
    <h1 class="text-h2 mb-16">Applications</h1>
    <Tabs
      v-model="tabSelectionIndex"
      :tabs="[{ title: 'Active' }, { title: 'Closed' }]"
      class="mb-24"
      :tabListClasses="['grid-cols-2', 'md:grid-cols-none']"
    />
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Tabs from '@/components/tabs/Tabs.vue';

export default defineComponent({
  name: 'ProviderApplications',
  components: { Tabs },
  data(): { tabSelectionIndex: number } {
    return { tabSelectionIndex: 0 };
  },
  watch: {
    $route: {
      handler(route: { name?: string }) {
        const routeToIndexMap: Record<string, number> = {
          'provider-applications-active': 0,
          'provider-applications-closed': 1,
        };
        const index = route.name ? routeToIndexMap[route.name] : undefined;
        if (index !== undefined && this.tabSelectionIndex !== index) {
          this.tabSelectionIndex = index;
        }
      },
      immediate: true,
    },
    tabSelectionIndex(newIndex: number): void {
      const routeNames = ['provider-applications-active', 'provider-applications-closed'];
      const routeName = routeNames[newIndex];
      if (routeName && this.$route.name !== routeName) {
        this.$router.push({ name: routeName });
      }
    },
  },
});
</script>
